import * as P from "../program-state"
import { preview_request_schema, preview_request_t, preview_response_schema, preview_response_t } from "../resource/types"
import { z } from "zod"

export const fetch_campaign_preview = async (
    request: preview_request_t,
    token: P.authn_token
): Promise<[boolean, preview_response_t | any]> => {
    try {
        
        const [ok, resp] = await P.issue_json_post(
            P.v1api`smart-campaign/preview/generate`,
            request,
            preview_response_schema,
            token
        )
        
        return [ok, resp]
    } catch (error) {
        console.error("Error fetching campaign preview:", error)
        return [false, error]
    }
}
